import react from "react";
import './style.less'
import {OverPack} from 'rc-scroll-anim';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import {Col, Row, Table} from "antd";

export default class SimulatorContent extends react.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const columns = [
            {
                title: '项目',
                dataIndex: 'name',
                key: 'name',
                render: text => <a>{text}</a>,
            },
            {
                title: '参数',
                dataIndex: 'Parameter',
                key: 'Parameter',
            },
            // {
            //     title: 'Remarks',
            //     dataIndex: 'Remarks',
            //     key: 'Remarks',
            // }
        ];

        const data = [
            {
                key: '1',
                name: '重量',
                Parameter: "158g",
                Remarks: '158gFull Carbon Filber Composite Material',
            },
            {
                key: '2',
                name: '尺寸',
                Parameter: "80*80*19mm",
                Remarks: '3m',
            },
            {
                key: '3',
                name: '供电电压',
                Parameter: "DC 5V",
                Remarks: '1.9m',
            },
            {
                key: '4',
                name: '工作温度',
                Parameter: "0-65℃",
                Remarks: '0.3m',
            },
            {
                key: '5',
                name: '供电接口',
                Parameter: "Type-C",
                Remarks: 'No hand controller required,fully autonomous vertical take-off and landing',
            },
            {
                key: '6',
                name: '设备接口',
                Parameter: "Type-C,3Pin Molex",
                Remarks: '≤15kg',
            },
        ];
        return (
            <OverPack className="simulator-content">
                <Row>
                    <Col xs={24} sm={24} md={12} lg={12} xl={10}>
                        <TweenOne key="0" animation={{opacity: 1}}
                                  className="simulator-img"
                                  style={{opacity: 0, marginBottom: 10}}
                        />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={14}>
                        <QueueAnim key="queue" leaveReverse>
                            <div key="a" className="code-box-shape queue-anim-demo">
                                <Table columns={columns} dataSource={data} pagination={false}
                                    title={() => "规格"}/>
                            </div>
                        </QueueAnim>
                    </Col>

                </Row>
            </OverPack>
        )
    }
}
